module.exports = __webpack_public_path__ + "img/section-img.f83cd0df.png";